import React from 'react'
import { makeStyles, Card, CardContent, Checkbox, FormControlLabel } from '@material-ui/core'

// Style
const useStyles = makeStyles({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: '#f8f8f8',
  },
  subText: {
    color: '#666666',
  },
})

export default function BehaviorCard({ listItems, checkedItems, setCheckedItems }) {
  const classes = useStyles()

  const handleChange = e => {
    if (checkedItems.includes(e.target.value)) {
      // 配列内にあったら
      setCheckedItems(
        checkedItems.filter(checkedItem => checkedItem !== e.target.value)
      )
    } else {
      setCheckedItems([...checkedItems, e.target.value])
    }
  }

  return (
    <Card className={classes.root}>
      <CardContent>
        <div style={{ paddingTop: '1.5rem' }}>
          {listItems.map((item, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedItems.includes(item.answer)}
                  onChange={handleChange}
                  value={item.answer}
                />}
              label={item.label}
              key={index}
            />
          ))}
        </div>
      </CardContent>
    </Card >
  )
}